// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.

import React from "react";
import { RouteComponentProps, Link } from "react-router-dom";
import { connect } from "react-redux";
import LoadingOverlay from "react-loading-overlay";
import Select from "react-select";
import Confirm from "../../common/confirm/confirm";
import axios from "axios";
import { bindActionCreators } from "redux";
import { Spinner, SpinnerSize } from "office-ui-fabric-react";
import ServiceHelper from "../../../../services/serviceHelper";
import OperationsHeader from "../header/operationsSubHeader";
import IUserModelActions, * as userModelActions from "../../../../redux/actions/modalActions";
import IUserOperationsActions, * as userOperationsActions from "../../../../redux/actions/operationsActions";
import { IAuthenticationState, IApplicationState,IConnection } from "../../../../models/applicationState";
import { getPrimaryRedTheme } from "../../../../common/themes";
import { toast } from "react-toastify";
import HeaderComponent from "../header/header";
import size from "lodash/size";
import { accessToken, queuefileUploadEndPoint } from "../../../../common/api-config";
import pdfImage from "../../../../assets/img/pdf.png";
import IFilesUploadingAction, * as filesUploadingAction from "../../../../redux/actions/filesUploadingAction";
import IProjectActions, * as projectActions from "../../../../redux/actions/projectActions";

export interface IQueueListProps extends RouteComponentProps, React.Props<QueueList> {
    userModelActions: IUserModelActions;
    loggedInUser: IAuthenticationState;
    userOperationsActions: IUserOperationsActions;
    filesUploadingAction: IFilesUploadingAction;
    actions: IProjectActions;
}

export interface IQueueListState {
    queueData: any;
    queuesList: any;
    addQueue: boolean;
    projectList: any;
    projectName: string;
    loadingQueues: boolean;
    loadingProjects: boolean;
    name: string;
    loaderText: string;
    selectedOption: any;
    selectedProject: any;
    description: string;
    healthQueueList: any;
    userFunctions: any;
    selectedFunction: any;

    fileNames: any[];
    fliesList: any[];
   // formData: IProject;
    newFiles: any[];
    lengthOfFiles: any;
    spinnerString: string;
    testUpload: boolean;
    keyword: string;
    goNextPage: boolean;
    spinner: boolean;
    userId: string;
    nextFromtest: boolean;
    connection: IConnection;
    filesCount:number;
}

function mapDispatchToProps(dispatch) {
    return {
        userModelActions: bindActionCreators(userModelActions, dispatch),
        userOperationsActions: bindActionCreators(userOperationsActions, dispatch),
        filesUploadingAction: bindActionCreators(filesUploadingAction, dispatch),
        actions: bindActionCreators(projectActions, dispatch),
    };
}

function mapStateToProps(state: IApplicationState) {
    return {
        loggedInUser: state.loggedInUser,
    };
}
@connect(mapStateToProps, mapDispatchToProps)

export default class QueueList

    extends React.Component<IQueueListProps, IQueueListState> {

    // public static getDerivedStateFromProps(nextProps, prevState) {
    //     const state = Object.assign({}, prevState);
    //     if (!state.projectName) {
    //         state.projectName = localStorage.getItem("project_name");
    //     }
    //     return state;
    // }

    public state: IQueueListState = {
        queueData: {},
        projectName: "Queue",
        selectedOption: null,
        name: "",
        loadingQueues: false,
        loadingProjects: false,
        selectedProject: [],
        queuesList: [],
        projectList: [],
        loaderText: "loading Your Models",
        description: "",
        addQueue: false,
        healthQueueList: [{
            date: "2020-06-24 07:40:15.406836", description: "Model", files: "3",
            project_name: "Queue", queue_name: "Object Detection"
        },
        {
            date: "2020-06-24 07:40:15.406836", description: "Model", files: "5",
            project_name: "Queue", queue_name: "Image Classification"
        },
        {
            date: "2020-06-24 07:40:15.406836", description: "Model", files: "2",
            project_name: "Queue", queue_name: "OCR"
        },
        {
            date: "2020-06-24 07:40:15.406836", description: "Function", files: "3",
            project_name: "Queue", queue_name: "User Defined"
        },
        ],
        userFunctions: [{ label: "User Defined", value: "user_defined" },
        { label: "Customer transformations", value: "customer_transformation" }],
        selectedFunction: null,
        fileNames: [],
      //  formData: {
       //     ...this.props.project,
       // },
        goNextPage: false,
        newFiles: [],
        spinnerString: "",
        fliesList: [],
        userId: null,
        lengthOfFiles: 0,
        testUpload: false,
        keyword: "training",
        spinner: false,
        nextFromtest: false,
        connection: { id: null, name: null, providerType: "azureBlobStorage", providerOptions: {} },
        filesCount:0,

    };


    private deleteQueueConfirm: React.RefObject<Confirm> = React.createRef();
    private deleteQueueCanceled: () => void;

    constructor(props) {
        super(props);
    }

    public async componentDidMount() {
       /* localStorage.removeItem("queue_name");
        this.getProjects();
        const { projectName } = this.state;
        if (projectName) { this.getQueues(); }*/

      //  clear all files in the common location

//deleteTestFiles
const user = this.props.loggedInUser;
const userId = user.user.oid;
this.setState({ userId });
 await this.props.userOperationsActions.deleteTestFiles(userId);

    }

    public render() {
       // const { addQueue } = this.state;

        const { fliesList, newFiles, lengthOfFiles, spinnerString, testUpload } = this.state;
        if (newFiles.length > 0) {
            const element = document.getElementById("myDocs");
            const element1 = document.getElementById("before-select");
            if (element && element1) {
                element.classList.add("loaded");
                element1.classList.add("after-select");
                element1.classList.remove("d-block");
            }
        }
       // debugger;
        const type = this.props.match.params["type"];
        //const type = this.props.match.params["type"];
        const minFileLength = testUpload ? 1 : 5;


        return (
            <>
                <HeaderComponent
                    history={this.props.history}
                    match={this.props.match}
                    location={this.props.location} />
                <LoadingOverlay
                    active={this.state.loadingProjects}
                    spinner
                    className={this.state.loadingProjects ? "wrap-queue-height" : ""}
                    text={this.state.loaderText}
                >
                    <OperationsHeader propsMatch={this.props.match} />

                    <div className="container-fluid animated fadeIn">
                            {/* <div className="row">
                        <div className="col-md-12">
                            <h4>Upload Files</h4>
                        </div>
                    </div> */}
                            <div className="row mt-3">

                                <div className="col-lg-2 ">

                                </div>
                                {/*
                                <div className="col-lg-4 ">
                                    Total number of Files uploaded so far: {lengthOfFiles}
                                </div>
                                <div className="col-lg-4 text-right ">
                                    Minimum Files Required: {minFileLength}
                                </div>*/
    }

                            </div>

                            <div className="row">

                                <div className="col-lg-2 ">

                                </div>

                                <div className="col-lg-8 ">
                                    <div id="myDocs" className="card wrap-upload shadow to-b-load">
                                        <div className="upload-block">
                                            {newFiles && newFiles.length > 0
                                                && newFiles.map((file, index) => {
                                                    return (
                                                        <div key={index} className="doc">
                                                            <img src={file.src} className="img-fluid" />
                                                            <div className="ann-info">
                                                                <a role="button" onClick={() => this.deleteFile(file)} className="cursor-pointer  del">
                                                                    <i className="fa fa-trash" aria-hidden="true"></i>
                                                                </a>
                                                                <div className="count">
                                                                    {index + 1}
                                                                </div>
                                                            </div>
                                                            <div className="doc-info">
                                                                <span className="name">{file.filename}</span>
                                                            </div>
                                                        </div>
                                                    );
                                                })}
                                            <input type="file" accept="application/pdf, image/jpeg, image/png, image/tiff"
                                                onChange={this.onChangeHandler}
                                                multiple
                                                id="before-select"
                                                className="upload-docs d-block" />
                                            <label htmlFor="upload">Drop files here or click to upload</label>
                                        </div>
                                        <div className="doc last-doc">
                                            <input type="file" accept="application/pdf, image/jpeg, image/png, image/tiff"
                                                multiple
                                                onChange={this.onChangeHandler} className="upload-docs d-block" />
                                            <div className="more-files">
                                                <i className="fa fa-upload" aria-hidden="true"></i><br />
                                                Click to upload more file</div>
                                        </div>
                                    </div>

                                </div>
                                <div className="col-lg-2 ">
                                </div>
                            </div>
                            <div className="row mt-2">

                                <div className="col-lg-2 ">

                                </div>

                                <div className="col-lg-8 text-center">
                                    <button onClick={() => this.uploadFileToAzure()}
                                        type="button" className="btn mr-2" >
                                        {/* <i className="fa fa-upload" aria-hidden="true"></i>  */}
                                        Next</button>
                                    {/* {this.state.goNextPage &&
                                        <button onClick={() => this.routeToPage()}
                                            type="button" className="btn" >
                                            Next</button>} */}
                                </div>
                            </div>
                        </div>
                 
                </LoadingOverlay>
            </>
        );
    }

    /**
     * Get Queue Data
     */
    private getQueueName = (event) => {
        this.setState({ ...this.state, [event.target.name]: event.target.value });
    }

    private setAddQueue = () => {
        const { addQueue } = this.state;
        this.setState({ addQueue: !addQueue });
    }
    /**
     * Create Queue
     */
    private createQueue = async () => {
        this.setState({ loadingQueues: true, loaderText: "Creating Queue", loadingProjects: true });
        let res;
        const { description, addQueue, projectName, name } = this.state;
        if (projectName && name && description) {
            const queueObject = {};
            queueObject["project_name"] = projectName;
            queueObject["queue_name"] = name;
            const data = {};
            data["description"] = description;
            let endPointdata = await this.props.userOperationsActions.createQueue(queueObject, data)
            res = endPointdata
            if (res == 'True') {
                this.setState({ loadingProjects: false, addQueue: !addQueue, description: "", name: "" });
                this.getQueues();
            } else {
                this.setState({ loadingProjects: false, loadingQueues: false });
            }
        } else {
            this.setState({ loadingProjects: false });
            toast.warn("Please Enter Fields", { position: toast.POSITION.TOP_CENTER });
        }
    }

    private deleteQueue = (model) => {
        /** Confirm to delete Project */
        this.deleteQueueConfirm.current.open(model);
    }

    private onDeleteProject = async (queue) => {
        this.setState({ loadingQueues: true });
        let status
        const data = await this.props.userOperationsActions.deleteUserQueue(queue)
        status = data
        if (status == 'True') {
            this.getQueues();
            this.setState({ loadingQueues: false });
        } else {
            this.setState({ loadingQueues: false });
        }
    }

    private async getQueues(): Promise<any> {
        const { projectName } = this.state;
        this.setState({ loadingQueues: true });
        const data = await this.props.userOperationsActions.userAllQueues(projectName)
        this.setState({ queuesList: data, loadingQueues: false });
    }

    private async getProjects(): Promise<any> {
        this.setState({ loadingProjects: true, loaderText: "Loading your Models" });
        const { projectName, projectList } = this.state;
        const data = await this.props.userModelActions.loadUserModels()
        const healthQueue = {
            OCR: "OCR",
            accuracy: 1,
            created_date: "2020-06-24 04:04:17.936572",
            hosted: "Hosted",
            labels: [],
            model_id: "86c1a648-c2f0-49cf-a3d9-122a3e0106e3",
            project_name: "Queue",
        }
        await this.setState({ projectList: data });
        await this.setState((prevState) => ({
            projectList: [...prevState.projectList, healthQueue], loadingProjects: false,
        }));
        if (projectName === "Queue") {
            this.setState({ projectName: healthQueue.project_name, selectedOption: healthQueue });
        } else {
            const projectValue = data.filter((project) => project.project_name === projectName);
            this.setState({ projectName: projectValue[0].project_name, selectedOption: projectValue });
        }
    }

    private onChange = async (values) => {
        this.setState({ loadingQueues: true });
        if (values) {
            await this.setState({ selectedOption: values, projectName: values.project_name });
            localStorage.setItem("project_name", values.project_name);
            this.getQueues();
        }
    }
    private onFunctionChange = (value: any) => {
        this.setState({ selectedFunction: value });
    }

      /**
     * private delete file
     */
    private deleteFile = (file) => {
        const { lengthOfFiles } = this.state;
        const newFiles = [...this.state.newFiles];
        const index = newFiles.indexOf(file);
        let arrayLength;
        if (index > -1) {
            newFiles.splice(index, 1);
            arrayLength = lengthOfFiles - 1;
        }
        this.setState({ newFiles, lengthOfFiles: arrayLength });
    }

    public onChangeHandler = (event) => {
        event.persist();
        if (event.target.files.length > 0) {
            const arrFiles = Array.from(event.target.files);
            arrFiles.forEach((file) => {
                this.getFileNameWithExt(file);
            });
        }
    }

    
    public uploadFileToAzure = async () => {

       // debugger;
        const { newFiles, keyword } = this.state;
       this.props.filesUploadingAction.clearFilesCount();
    
      this.props.actions.clearTestBlobs();
       //
           //clear all files
       //
        const projectName = this.props.match.params["projectName"];
        const schemaParam = keyword === "testing" ? "na" : this.props.match.params["schema"];
       
        const projectId =this.props.match.params["projectId"] ?this.props.match.params["projectId"] :"";
        let typeParam ;       

        if(projectId)
        {
          //  typeParam = this.props.project.projType;//?this.props.project.projType:"na";
        }
        else
        {
          //  typeParam = this.props.match.params["type"]; // this.props.project.projType?this.props.project.projType:"na";
        }      
         if(!typeParam)
         {
            typeParam = this.props.match.params["type"];
         }
       
        if (size(newFiles) > 0) {
             console.log("new files count1:"+size(newFiles));
            // console.log("new files count2:"+newFiles.length);
            this.setState({ spinnerString: "Uploading Files", spinner: true, filesCount:size(newFiles).toString()
        });
            if (!this.props.match.params["projectId"] || keyword === "testing") {
                if (keyword !== "testing") {
                    const modelObject = {
                        project_name: projectName,
                        user_id: this.state.userId,
                        schema: schemaParam,
                        project_type: "ocr",
                    };
                   // this.props.projectActions.createNewModel(modelObject);
                  //  await this.projectObject();
                }
            }
            const tempArray = [];
            const tempUrls = [];
            let uploadFile = null;
            this.closeToast(false);
           // const stringName = keyword === "testing" ? "OPtestFilesLengthFromTest" : "OPfilesLengthFromModel";
           const stringName =  "OPtestFilesLengthFromTest" ;
           localStorage.setItem(stringName, this.state.lengthOfFiles.toString());
            newFiles.forEach(async (file, index) => {
                const formData = new FormData();                              
              const name = file.filename;
              const lastDot = name.lastIndexOf(".");
        const fileName = name.substring(0, lastDot);
        const ext = name.substring(lastDot + 1);

              //if PDF 
              try {
                let result ;
              if(ext === "pdf")
              {
              formData.append("name", file.file);
              const URL = queuefileUploadEndPoint(file.filename);
              result = await this.axiosPromise(URL, formData); 
            }
              else
              {
             
             
             //  formData.append("name", file);
               formData.append("name", file.file);
               const imgblob = new Blob([file.file], { type: 'image/jpeg'} );
               formData.append("content", imgblob);
               formData.append("src", window.URL.createObjectURL(file.file));
               const URL = queuefileUploadEndPoint(file.filename );
               result = await this.axiosPromiseimg(URL, formData, imgblob);
              }
              // else img

               // const URL = fileUploadEndPoint(projectName, file.filename, keyword, schemaParam, typeParam);
               
               // const result = await this.axiosPromise(URL, formData);
                if (result && result.data && result.data.status === "true") {
                   this.props.filesUploadingAction.setFilesCount();
                    if (index === newFiles.length - 1) {
                        uploadFile = true;
                       this.closeToast(true);
                    }
                    toast.success(`${result.data.file_name} Uploaded Successfully`, { position: toast.POSITION.TOP_CENTER, autoClose: 2000 });
                } else if (result && result.data && result.data.status === "false") {
                    const { lengthOfFiles } = this.state;
                    const newFiles = [...this.state.newFiles];
                    const index = newFiles.indexOf(file);
                    let arrayLength;
                    if (index > -1) {
                        newFiles.splice(index, 1);
                        arrayLength = lengthOfFiles - 1;
                    }
                    if (index === newFiles.length - 1) {
                        this.closeToast(true);
                    }
                    const stringName = keyword === "test" ? "testFilesLengthFromTest" : "filesLengthFromModel";
                    localStorage.setItem(stringName, arrayLength.toString());
                    toast.warn(`${result.data.file_name} Failed`, { position: toast.POSITION.TOP_CENTER, autoClose: 2000 });
                } else {
                    this.closeToast(true);
                }
                } catch(err) {
                    ServiceHelper.handleServiceError(err);
                };
            });
            localStorage.setItem("project_name", projectName);
         
             const urlPath = keyword === "testing" ? `${typeParam}/test-files` : `${typeParam}/edit`;
const nooffile = size(newFiles);
console.log("new files count2:"+size(newFiles));
const pushurl = "/operations/TestQueueProjects/"+nooffile;
             setTimeout(() => {                  
                this.props.history.push(pushurl) }, 500);   

             /*
             if(typeParam === 'ocr')
             {
                setTimeout(() => {                    
                    this.props.history.push(`/OCRProjects/${projectName}/${this.props.match.params["projectId"] || this.props.project.id}/${urlPath}/${schemaParam}`);
                   
                  }, 500);                   
             }
         else if(typeParam === 'od')
            {  
             setTimeout(() => {                  
                    this.props.history.push(`/ODProjects/${projectName}/${this.props.match.params["projectId"] || this.props.project.id}/${urlPath}/${schemaParam}`);
                   
               }, 500);                
             } 
*/

            // else
            // {
            //     console.log("error -not able to fetch the project type");
             //}
             //

           
         //   setTimeout(() =>             
             // this.props.history.push(`/projectsFR/${projectName}/${this.props.match.params["projectId"] || this.props.project.id}/${urlPath}/${schemaParam}`);
             
           // }, 500);

        } else {
            this.routeToPage();
/*
            if (this.state.goNextPage) {
                this.routeToPage()
            } else {
            toast.warn("Please select minimum one file.", { position: toast.POSITION.TOP_CENTER });
            }
            */

        }
    }

    public getFileNameWithExt = async (file) => {
        let { fileNames, newFiles, lengthOfFiles, fliesList } = this.state;
        const name = file.name;
        const lastDot = name.lastIndexOf(".");
        const fileName = name.substring(0, lastDot);
        const ext = name.substring(lastDot + 1);
//^[a-zA-Z]+[a-zA-Z0-9-_]*

//
//const regexQuery =  "^([a-zA-Z]+[a-zA-Z0-9-_]*)$"; 
//const regexQuery = "^([a-zA-Z]+[a-zA-Z0-9-_]*\.[A-Za-z]{3,4})$";
const regexQuery = "^([a-zA-Z0-9-_]{2,50}\.[A-Za-z]{3,4})$";
const url = new RegExp(regexQuery, "i");
console.log("filename==>"+name);
if (url.test(name)) {

//
         
        if (fileNames.indexOf(name) === -1) {
            const src = ext === "pdf" ? pdfImage : window.URL.createObjectURL(file);
            const fileData = {};
            fileData["file"] = file;
            fileData["src"] = src;
            fileData["filename"] = name;
            fileNames.push(file["name"]);
            newFiles.push(fileData);
        } else {
            fileNames = fileNames;
            newFiles = newFiles;
            toast.success(`${file["name"]} file is exists`, { position: toast.POSITION.TOP_CENTER });
        }
    }
    else
    {
        fileNames = fileNames;
        newFiles = newFiles;
        toast.warn(`${file["name"]} file is invalid`, { position: toast.POSITION.TOP_CENTER });
    }
        const arrayLength = newFiles.length + lengthOfFiles;
        await this.setState({
            fileNames,
            lengthOfFiles: arrayLength,
            newFiles,
        });
    }


    public getFileNameWithExt_old = async (file) => {
        let { fileNames, newFiles, lengthOfFiles, fliesList } = this.state;
        const name = file.name;
        const lastDot = name.lastIndexOf(".");
        const fileName = name.substring(0, lastDot);
        const ext = name.substring(lastDot + 1);
        if (fileNames.indexOf(name) === -1) {
            const src = ext === "pdf" ? pdfImage : window.URL.createObjectURL(file);
            const fileData = {};
            fileData["file"] = file;
            fileData["src"] = src;
            fileData["filename"] = name;
            fileNames.push(file["name"]);
            newFiles.push(fileData);
        } else {
            fileNames = fileNames;
            newFiles = newFiles;
            toast.success(`${file["name"]} file is exists`, { position: toast.POSITION.TOP_CENTER });
        }
        const arrayLength = newFiles.length + lengthOfFiles;
        await this.setState({
            fileNames,
            lengthOfFiles: arrayLength,
            newFiles,
        });
    }

    
    public axiosPromiseimg = (URL: string, formData, imgblob) => {
        const headers = accessToken();
 
       //  return axios(URL, { method: "POST", data: formData, headers });
         return axios(URL, { method: "POST",data:imgblob , headers });
     }
 
    public axiosPromise = (URL: string, formData) => {
       const headers = accessToken();
       /* const signInUserSession = localStorage.getItem("signInUserSession");
        const user = signInUserSession && JSON.parse(signInUserSession);
        const accessToken = user && user.access_token;
        //const headers = {'Content-Type': `multipart/form-data; boundary=${formData._boundary}`, 
         //"Authorization": `Bearer ${accessToken}`, "cache-control": "no-cache" };
      
      */   
      //  const headers = {'Content-Type': 'multipart/form-data', "Authorization": `Bearer ${accessToken}`, "cache-control": "no-cache" };
      
       //  const headers = {"Authorization": `Bearer ${accessToken}`, "cache-control": "no-cache" };
      
        //console.log(JSON.stringify(formData));
      //  debugger;

   /*  return   fetch(URL, {
            method: 'POST',
            headers: {         
          'Authorization': `Bearer ${accessToken}`
            },
            body: formData
          }).then((response) => {
              debugger;
              console.error("response:"+response);
            return response.json();
          })
           .catch((error) => {
            console.error(error);
            return error.json();
          });*/

        //  return result;
        return axios(URL, { method: "POST", data: formData,headers });
/*
       return axios({
        method: 'post',
        url: URL,
        data: formData ,
       // headers: headers
        });
*/
    }

    
    public closeToast = (showUploadToast: boolean) => {
        const closeToast = showUploadToast ? 7000 : false;
        if (!showUploadToast) {
            toast.info(this.renderSpinner(),
            { className: "toast-inf-bg-color", toastId: 1, position: toast.POSITION.TOP_CENTER, hideProgressBar: false, autoClose: closeToast });
        }
        if (toast.isActive(1)) {
            toast.update(1,
            {  render: this.renderSpinner(), type: toast.TYPE.INFO, position: toast.POSITION.TOP_CENTER, hideProgressBar: false, autoClose: closeToast });
        }
    }
    public renderSpinner = () => {
        return (
            <div className="asset-loading">
            <div className="asset-loading-spinner">
            <Spinner label=" Your files are Uploading..." size={SpinnerSize.small} labelPosition="left" />
            </div>
        </div>
        )
    }
    
    public routeToPage = async () => {
        const { keyword } = this.state;
        await this.setState({ nextFromtest: true });
       // await this.projectObject();
        //const projectName = this.props.match.params["projectName"];
      //  const projectId = this.props.match.params["projectId"];
       
      //  const type = this.props.match.params["type"];
       // const typeParam = this.props.project.projType ? this.props.project.projType:"na";
       const schemaParam = "na" ;
        const typeParam =  "na";
        const type = "na";
        const urlPath = keyword === "testing" ? `${type}/test-files` : `${type}/edit`;
       // this.props.history.push(`/OCRProjects/${projectName}/${projectId}/${urlPath}/${schemaParam}`);
       this.props.history.push(`/operations/TestQueueProjects`);
        /*const schemaParam = keyword === "testing" ? "na" : this.props.match.params["schema"];
    const urlPath = keyword === "testing" ? `${type}/test-files` : `${type}/edit`;
//this.props.history.push(`/OCRProjects/${projectName}/${projectId}/${urlPath}/${schemaParam}`);
if(type === 'ocr')
{
        this.props.history.push(`/OCRProjects/${projectName}/${projectId}/${urlPath}/${schemaParam}`);
}
else if(type === 'od')
{    
    this.props.history.push(`/ODProjects/${projectName}/${projectId}/${urlPath}/${schemaParam}`); 
} 
else
{
    console.log("error -not able to fetch the project type");
}*/
    }
}
